import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ObjectIndexPage } from "@/features/customobjects/ObjectIndexPage";

const search = z.object({
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/o/$object/")({
  validateSearch: search,
  component: () => <ObjectIndexPage objectId={Route.useParams().object} search={Route.useSearch()} />,
});
